import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import ActionDropdown from "../../components/actions/ActionDropdown";
import Button from "../../components/common/button/Button";
import {useDispatch, useSelector} from "react-redux";
import {getTableColumns, getTableData} from "../../models/domainModel";
import {deleteDomain, fetchAllDomain, resetCreateStatus, resetUpdateStatus} from "../../store/domain-slice";
import Table from "../../components/common/table/Table";

const DomainView = () => {
    const dispatch = useDispatch();

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        error,
    } = useSelector(state => state.domain); // Updated to customer slice

    useEffect(() => {
        dispatch(fetchAllDomain());
    }, [dispatch]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteDomain({id}));
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});
    return (
        <>
            <SubHeader title="All Domain">
                <Button to="add" className="bg-primary bg-opacity-50">Add</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                />
            )}
        </>
    )
}

export default DomainView;